const routes = [
    {
        path: '/contabilidade/dominio_sistemas/integracoes/:hash',
        alias: ['/contabilidade/dominio_sistemas/integracoes/index/:hash'],
        component: () => import('../views/Listar'),
    },
    {
        path: '/contabilidade/dominio_sistemas/integracoes/configurar/:hash',
        component: () => import('../views/Configurar'),
    },
    {
        path: '/contabilidade/dominio_sistemas/integracoes/visualizar/:hash',
        component: () => import('../views/Visualizar'),
    },
]

export default routes